/**
 * CurrencySelect.js
 * Компактный селектор валюты для форм (расход, доход, AMC, прайс, billing).
 * По умолчанию форма подставляет базовую валюту орги; здесь пользователь может
 * быстро сменить валюту для конкретной транзакции.
 *
 * Все подписи — через справочник валют (utils/money), готово к мультиязычности:
 * названия валют берутся по локали.
 *
 * PostHog: смена валюты трекается событием currency_changed (place — откуда).
 */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { CURRENCY_CODES, CURRENCIES } from '../utils/money';
import { track } from '../analytics';

export default function CurrencySelect({
  value,
  onChange,
  place = 'unknown',
  disabled = false,
  className = 'form-input',
  style,
  ariaLabel,
  compact = false, // true → в опциях только ISO-код (для компактного селектора в поле суммы)
}) {
  const { i18n } = useTranslation();
  const ru = String(i18n.language || '').startsWith('ru');

  const handle = (e) => {
    const next = e.target.value;
    if (next !== value) track('currency_changed', { place, from: value || null, to: next });
    onChange(next);
  };

  return (
    <select
      className={className}
      style={style}
      value={value || 'AED'}
      onChange={handle}
      disabled={disabled}
      aria-label={ariaLabel || 'currency'}
      data-ph-capture-attribute-currency-select={place}
    >
      {CURRENCY_CODES.map((code) => (
        <option key={code} value={code}>
          {compact ? code : `${code} · ${ru ? CURRENCIES[code].nameRu : CURRENCIES[code].nameEn}`}
        </option>
      ))}
    </select>
  );
}
